export const SEND_SOURCE_LABELS = {
    Journey: "Journey",
    ContentPack: "Content pack",
    OnDemand: "On demand",
    AutoAssign: "Auto assign",
    Direct: "Direct"
};

export const SEND_SOURCE_NONE = "None";

export const SEND_SOURCE_OPTIONS = Object.entries(SEND_SOURCE_LABELS).map(([value, label]) => ({ value, label }));

export const formatSendSource = (source, sourceName) => {
    if (!source) {
        return "-";
    }

    const label = SEND_SOURCE_LABELS[source] || source;
    return sourceName ? `${label} - ${sourceName}` : label;
};
